/**
 * 从对象提取所需字段
 * @param {object} data
 * @param {array} keys
 * @returns object
 * eg:
 * pick({name: 'zhang', age: 12, color: 'blue'}, ['name']) => {name: 'zhang'}
 * pick({name: 'zhang', age: 12, color: 'blue'}, ['name', ['age', 'year']]) => {name: 'zhang', year: 12}
 */
export function pick(data, keys) {
  var result = {};
  keys.forEach(function (key) {
    var newKey;

    if (Array.isArray(key)) {
      var _key = key,
          okey = _key[0],
          nkey = _key[1];
      key = okey;
      newKey = nkey;
    } else {
      newKey = key;
    }

    result[newKey] = data[key];
  });
  return result;
}
export function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      return resolve(true);
    }, ms);
  });
} // 版本号比较： 判断版本比对结果是否成立，  include:是否包含

export var versionCompare = function versionCompare(minVersion, maxVersion, include) {
  if (include === void 0) {
    include = true;
  }

  if (!minVersion || !maxVersion) return;
  if (include && minVersion === maxVersion) return true;
  var mins = minVersion.split('.');
  var maxs = maxVersion.split('.');

  for (var i = 0; i < maxs.length; i++) {
    var max = maxs[i];
    var min = mins[i];

    if (max > min) {
      return true;
    } else if (max < min) {
      return false;
    }
  }

  return false;
};
/**
 * 获取本地存储的数据，同时返回修正过的结果
 * @param key key
 * @returns 
 */

export var getLocalStorage = function getLocalStorage(key) {
  var value = window.localStorage.getItem(key);
  if (!value || value === 'null' || value === 'undefined') return '';
  return value;
};